export default "{\n    \"viewAllLinkText\": \"View all\"\n}\n"